import icn_table_cell_change from "assets/images/icons/icn_table_cell_change.svg";
import icn_table_cell_change_hover from "assets/images/icons/icn_table_cell_change_hover.svg";
import icn_table_cell_Logout from "assets/images/icons/icn_table_cell_Logout.svg";
import icn_table_cell_Logout_hover from "assets/images/icons/icn_table_cell_Logout_hover.svg";
import icn_table_cell_Bin from "assets/images/icons/icn_table_cell_Bin.svg";
import icn_table_cell_Bin_hover from "assets/images/icons/icn_table_cell_Bin_hover.svg";

import icn_dashboard_switch from "assets/images/icons/icn_dashboard_switch.svg";
import icn_dashboard_switch_off from "assets/images/icons/icn_dashboard_switch_off.svg";
import icn_dashboard_ap from "assets/images/icons/icn_dashboard_ap.svg";
import icn_dashboard_ap_off from "assets/images/icons/icn_dashboard_ap_off.svg"

export const ALL_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Wireless", "Network"],
    columns: {
      "Wireless": [
        "2", "5", "6",
        "c2_4G", "c5G", "c6G"
      ],
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"]
    }
  },
  {
    groupNames: ["Statistic"],
    columns: {
      "Statistic": ["traffic24HrUsage", "cpuStats", "memoryStats"]
    }
  }
]

export const AP_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Wireless", "Network"],
    columns: {
      "Wireless": [
        "2", "5", "6",
        "c2_4G", "c5G", "c6G"
      ],
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"]
    }
  },
  {
    groupNames: ["Statistic"],
    columns: {
      "Statistic": ["traffic24HrUsage", "cpuStats", "memoryStats"]
    }
  }
]

export const SW_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Network", "Statistic"],
    columns: {
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"],
      "Statistic": ["traffic24HrUsage", "cpuStats", "memoryStats"]
    }
  }
]

export const RTR_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Network", "Statistic"],
    columns: {
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"],
      "Statistic": ["traffic24HrUsage", "cpuStats", "memoryStats"]
    }
  }
]

export const INV_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Network"],
    columns: {
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"],
    }
  }
]

export const PROXY_VISIBILITY_GROUP_DATA = [
  {
    groupNames: ["Device"],
    columns: {
      "Device": [
        "linkStatus", "deviceName", "siteName",
        "syncStatus", "connect", "macAddress",
        "modelName", "hardwareVersion", "serialNumber",
        "deviceTag", "clients", "joinedOn",
        "licenseStatus", "firmwareVersion", "uptime",
        "description", "address"
      ]
    }
  },
  {
    groupNames: ["Network", "Statistic"],
    columns: {
      "Network": ["lastOfflineTime", "localIpAddr", "publicIpAddr", "uplinkDeviceName"],
      "Statistic": ["traffic24HrUsage", "cpuStats", "memoryStats"]
    }
  }
]

export const BATCH_ACTION_LIST = [
  {
    key: 'change',
    label: 'Move to Site',
    icon: icn_table_cell_change,
    iconHover: icn_table_cell_change_hover,
    modalKey: 'moveToSite',
    permissions: ['org']
  },
  {
    key: 'logout',
    label: 'Remove from Site',
    icon: icn_table_cell_Logout,
    iconHover: icn_table_cell_Logout_hover,
    modalKey: 'removeFromSite',
    permissions: ['org', 'site']
  },
  {
    key: 'bin',
    label: 'Delete Device',
    icon: icn_table_cell_Bin,
    iconHover: icn_table_cell_Bin_hover,
    modalKey: 'deleteDevice',
    permissions: ['org']
  },
];

export const BATCH_ACTION_MODAL_TITLE = {
  moveToSite: "Move To Site",
  removeFromSite: "Remove From Site",
  deleteDevice: "Delete Device",
}

export const BATCH_ACTION_MODAL_DEVICE_ICONS = {
  switch: {
    online: icn_dashboard_switch,
    offline: icn_dashboard_switch_off,
  },
  ap: {
    online: icn_dashboard_ap,
    offline: icn_dashboard_ap_off,
  },
};

export const BATCH_ACTION_MODAL_DESCRIPTION = {
  moveToSite: () => "Adopt selected devices into the new site to apply its configurations.",
  removeFromSite: (siteName) => (
    <>
      Remove selected devices from the site: <b>&lt; {siteName} &gt;</b> while keeping them in the organization inventory.
    </>
  ),
  deleteDevice: () => (
    <>
      <b>Warning:</b> Selected devices will be permanently deleted from the organization.
      This action is irreversible.
    </>
  ),
};

export const BATCH_ACTION_MODAL_BUTTON_NAME = {
  moveToSite: "Move",
  removeFromSite: "Remove",
  deleteDevice: "Delete"
};